import { render } from "./ProjectTabInvoice.vue?vue&type=template&id=e37865ce&scoped=true&ts=true"
import script from "./ProjectTabInvoice.vue?vue&type=script&lang=ts"
export * from "./ProjectTabInvoice.vue?vue&type=script&lang=ts"

import "./ProjectTabInvoice.vue?vue&type=style&index=0&id=e37865ce&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37865ce"]])

export default __exports__